import {MutationCache, QueryClient, QueryClientProvider} from '@tanstack/react-query';
import React, {useState} from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import {Toaster} from 'react-hot-toast';
import {Provider} from 'react-redux';
import {BrowserRouter} from 'react-router-dom'; 
import {PersistGate} from 'redux-persist/integration/react';

import App from './App';
// import {FilterProvider} from './context/FilterContext/FilterContext';
import store, {persistor} from './redux/store/configureStore';
import reportWebVitals from './reportWebVitals';
import 'aos/dist/aos.css';
   
const queryClinet = new QueryClient({
  mutationCache: new MutationCache({
    onSuccess: () => {
     
      queryClinet.invalidateQueries();
    },
  }),
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      staleTime: 0,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate persistor={persistor} loading={null}>
        <QueryClientProvider client={queryClinet}>
          <BrowserRouter> 
            <Toaster position={'top-center'} reverseOrder={false} />
            <App />
          </BrowserRouter>
        </QueryClientProvider>
      </PersistGate>
    </Provider>
  </React.StrictMode>,
);

reportWebVitals();

document.addEventListener('input', e => {
  if (e.target.tagName === 'INPUT' || e.target.tagName === 'TEXTAREA') {
    if (e.target.value.startsWith(' ')) {
      e.target.value = e.target.value.trimStart();
    }
  }
});
